import React, { useEffect, useState } from "react";
import {
	Typography, Avatar, Button, createStyles, Box,
} from "@material-ui/core";
import Lock from "@material-ui/icons/Lock";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { RouteComponentProps, withRouter } from "react-router-dom";
import firebase from "../firebase";
import IntroContainer from "../shared/IntroContainer";

const styles = () => {
	return createStyles({
		avatar: {
			margin: "0 auto 10px auto",
			fontSize: 40,
			width: 60,
			height: 60,
		},

	});
};

// eslint-disable-next-line @typescript-eslint/naming-convention
function Dashboard(props: RouteComponentProps & WithStyles): JSX.Element {
	const { classes } = props;

	const currentUser = firebase.getCurrentUser();
	const [checking, setChecking] = useState(false);

	if (!firebase.getCurrentUser()) {
		props.history.replace("/login");
	}

	if (firebase.getCurrentUser()?.emailVerified) {
		props.history.replace("/dashboard");
	}

	async function logout() {
		await firebase.logout();
		props.history.push("/");
	}

	async function checkStatus() {
		setChecking(true);
		try {
			await firebase.getCurrentUser()?.reload();
			if (firebase.getCurrentUser()?.emailVerified) {
				props.history.replace("/dashboard");
			}
		} finally {
			setChecking(false);
		}
	}

	useEffect(() => {
		// Listen for auth state changes instead of polling
		const unsubscribe = firebase.auth.onAuthStateChanged(async (user) => {
			if (user) {
				// Reload user to get the latest emailVerified status
				await user.reload();
				if (user.emailVerified) {
					props.history.replace("/dashboard");
				}
			}
		});
		
		return () => unsubscribe();
	}, [props.history]);

	return (
		<>
			{
				currentUser && (
					<IntroContainer>
						<Avatar className={classes.avatar}>
							<Lock fontSize="inherit" />
						</Avatar>
						<Typography component="h1" variant="h5">
							Hello
							{" "}
							{currentUser?.displayName}
							,
						</Typography>
						<Typography component="h1" variant="body1">
							Please follow the link we've sent to
							{" "}
							{currentUser?.email}
							{" "}
							in order to verify your account.
						</Typography>
						<Box marginTop="20px">
							<Button
								type="button"
								fullWidth
								variant="contained"
								color="primary"
								onClick={checkStatus}
								size="large"
								disableElevation
								disabled={checking}
								style={{ marginBottom: "10px" }}
							>
								{checking ? "Checking..." : "I've Verified My Email"}
							</Button>
							<Button
								type="submit"
								fullWidth
								variant="outlined"
								color="secondary"
								onClick={logout}
								className={classes.submit}
								size="large"
								disableElevation
							>
								Logout

							</Button>
						</Box>
					</IntroContainer>
				)
			}
		</>
	);
}

export default withRouter(withStyles(styles)(Dashboard));
